import React, { useEffect } from 'react';

import { Badge, List, Typography } from 'antd';
import { generatePath } from 'react-router-dom';

import { MenuItemWrapper, UserAvatar } from 'common-ui';
import { conversationsApi, selectWebSocketStatus, useAppSelector } from 'core/lib';
import colors from 'core/lib/theme/colors';
import { HubConnectionState } from 'core/lib/utils/signalR/utils';
import { Routes } from 'routes/routes';
import { useMatchParamId } from 'utils/hooks';
import { useHub } from 'utils/hooks/hubHooks';

import { CreateDirectConversationPopover } from '../components';

const { Text } = Typography;

const DirectConversationsMenu = () => {
  const { data = [], isFetching } = conversationsApi.useGetMyMenuDirectConversationsQuery();
  const [hub] = useHub();
  const webSocketStatus = useAppSelector(selectWebSocketStatus);

  const routeConvId = useMatchParamId(Routes.CONVERSATIONS_DM_DETAILS.path);

  const isActive = (directConversationId: number) => {
    return routeConvId && parseInt(routeConvId) === directConversationId;
  };

  useEffect(() => {
    if (webSocketStatus === HubConnectionState.Connected) {
      hub.conversations.joinDirectConversationMenu();
    }
    return () => {
      hub.conversations.leaveDirectConversationMenu();
    };
  }, [hub.conversations, webSocketStatus]);

  return (
    <div className="flex flex-col gap-2">
      <List
        className="empty-list-no-image"
        locale={{ emptyText: <></> }}
        loading={isFetching}
        split={false}
        dataSource={data}
        renderItem={(conversation) => {
          return (
            <MenuItemWrapper
              isActive={!!isActive(conversation.id)}
              path={generatePath(Routes.CONVERSATIONS_DM_DETAILS.path, { id: conversation.id })}
              linkClassName="py-2"
              menuItemClassName="px-4"
            >
              <Text className="text-inherit gap-2" ellipsis>
                <UserAvatar plain size="small" user={conversation.peer} />
              </Text>
              <Badge
                count={conversation.undreadMessages}
                className="leading-auto"
                style={{ backgroundColor: colors.Primary.rgba }}
              />
            </MenuItemWrapper>
          );
        }}
      />
      <CreateDirectConversationPopover />
    </div>
  );
};

export default DirectConversationsMenu;
